import type { Theme } from '../../types/theme';

export const teslaTheme: Theme = {
  id: 'tesla',
  name: 'Tesla',
  description: 'Radical subtraction with full-viewport photography and single blue CTA',
  sourceDesignMd: 'https://github.com/nexu-io/open-design/blob/main/design-systems/tesla/DESIGN.md',
  visualKeywords: ['minimal', 'photography-first', 'Universal Sans', 'blue CTA', 'electric'],
  colors: {
    background: '#ffffff',
    surface: '#ffffff',
    surfaceElevated: '#ffffff',
    textPrimary: '#171a20',
    textSecondary: '#5c5e62',
    textMuted: '#5c5e62',
    border: '#eeeeee',
    borderSubtle: '#e4e4e4',
    primary: '#3e6ae1',
    primaryHover: '#4d79f0',
    primaryActive: '#204cc3',
    accent: '#3e6ae1',
    onPrimary: '#ffffff',
    success: '#22c55e',
    warning: '#f59e0b',
    error: '#ef4444',
  },
  typography: {
    headingFont: 'Inter, system-ui, sans-serif',
    bodyFont: 'Inter, system-ui, sans-serif',
    monoFont: 'JetBrains Mono, monospace',
    headingWeight: '600',
    bodyWeight: '400',
    letterSpacingHeading: '-0.02em',
    letterSpacingBody: '0',
  },
  radius: {
    button: '6px',
    card: '8px',
    panel: '8px',
    badge: '4px',
    input: '6px',
  },
  shadow: {
    card: '0 1px 3px rgba(0,0,0,0.1)',
    elevated: '0 4px 12px rgba(0,0,0,0.15)',
    button: '0 1px 2px rgba(0,0,0,0.1)',
    none: 'none',
  },
  layout: {
    maxWidth: '1280px',
    sectionSpacing: '80px',
    cardPadding: '24px',
    navHeight: '64px',
  },
  mood: {
    density: 'low',
    tone: 'premium',
    productFit: [],
    bestFor: [],
    notGoodFor: [],
  },
};
